export default "__VITE_ASSET__kKGU6F3i__"